module.exports = __webpack_public_path__ + "static/bg2-843781834b1db2908f08d921c6460c81.jpg";